// The V2 API returns `id`, while the request modals still read Mongo-style `_id`
// on the row, its user and its attendance log. Copy `id` across so both work.
const withMongoId = (obj) => (obj && typeof obj === 'object' ? { ...obj, _id: obj._id || obj.id } : obj);

export const normalizeRequest = (row) => ({
    ...withMongoId(row),
    user: withMongoId(row.user),
    attendanceLog: withMongoId(row.attendanceLog),
});
